var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel",on:{"mouseenter":_vm.pauseRotation,"mouseleave":_vm.unpauseRotation}},[_c('transition',{attrs:{"name":"transition"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }